import React from 'react';
import { Modal, ModalBody, Row, Col, Container, Input, Label, Table, Button, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import Translate, { t } from '../Translate';

export const AlertModalHistovec = ({
  isOpen,
  toggle,
  body,
  handleCancel,
  size,
  histovecStatus,
  histovecAlerts,
  privateOwner,
  retriveHistovecInfo,
  companyOwner,
  setHistoryChanges,
  ownerMode,
  setOwnerMode,
  handleKeyPress,
}) => {
  const status = histovecStatus?.status;
  const reportLink = histovecAlerts?.[0]?.reportLink;
  const formulaExp = new RegExp('^[0-9]{4}[a-zA-Z]{2}[0-9]{5}$');
  const sirenExp = new RegExp('^[0-9]');
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size={size}>
      {!body && (
        <ModalBody>
          {!status || status === 'failed' || status === 'pending' ? (
            <>
              {status === 'pending' && <h3 className="text-danger text-center"> {t('histovecAlertPendingMessage')}</h3>}
              {status === 'failed' && <h3 className="text-danger text-center"> {t('histovecAlertFailedMessage')}</h3>}
              <Switcher ownerMode={ownerMode} setOwnerMode={setOwnerMode} />
              {ownerMode === 'private' && (
                <SwitchOwnerMode
                  type="private"
                  className={`d-md-block ${ownerMode === 'private' ? '' : 'd-none'}`}
                  setHistoryChanges={setHistoryChanges}
                  privateOwner={privateOwner}
                  histovecStatus={histovecStatus}
                />
              )}
              {ownerMode === 'company' && (
                <SwitchOwnerMode
                  type="company"
                  className={`d-md-block ${ownerMode === 'company' ? '' : 'd-none'}`}
                  setHistoryChanges={setHistoryChanges}
                  companyOwner={companyOwner}
                  histovecStatus={histovecStatus}
                  handleKeyPress={handleKeyPress}
                />
              )}
              <Row className="justify-content-center mt-3">
                <Col xs={12} lg={6}>
                  <button className="btn btn-block btn-3 mb-2" onClick={handleCancel} type="button">
                    <Translate code="close" />
                  </button>
                </Col>
                <Col xs={12} lg={6}>
                  <button
                    className={`btn btn-block btn-1 ${status === 'pending' ? 'bg-secondary' : ''}`}
                    disabled={
                      !(
                        (ownerMode === 'private' &&
                          (privateOwner.privateName !== '' || histovecStatus?.privateName) &&
                          (privateOwner.privateLastName !== '' || histovecStatus?.privateLastName) &&
                          (formulaExp.test(privateOwner.privateFormula) ||
                            formulaExp.test(histovecStatus?.privateFormula))) ||
                        (ownerMode === 'company' &&
                          (companyOwner.companyName !== '' || histovecStatus?.companyName) &&
                          (formulaExp.test(companyOwner.companyFormula) ||
                            formulaExp.test(histovecStatus?.companyFormula)) &&
                          (sirenExp.test(companyOwner.companySiren) || sirenExp.test(histovecStatus?.companySiren)))
                      ) || status === 'pending'
                    }
                    onClick={retriveHistovecInfo}
                    type="button"
                  >
                    <Translate code="retriveHistovecInfo" />
                  </button>
                </Col>
              </Row>
            </>
          ) : (
            <>
              {histovecAlerts && histovecAlerts.length > 0 && (
                <HistovecAlertsTable
                  histovecAlerts={histovecAlerts}
                  reportLink={reportLink}
                  histovecStatus={histovecStatus}
                  handleCancel={handleCancel}
                />
              )}
            </>
          )}
        </ModalBody>
      )}
    </Modal>
  );
};

const Switcher = ({ ownerMode, setOwnerMode }) => (
  <div className="menu-switcher">
    <ul>
      <li className={ownerMode === 'private' ? 'active' : ''}>
        <div role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => setOwnerMode('private')}>
          <Translate code="private" />
        </div>
      </li>
      <li className={ownerMode === 'company' ? 'active' : ''}>
        <div role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => setOwnerMode('company')}>
          <Translate code="company" />
        </div>
      </li>
    </ul>
  </div>
);

const SwitchOwnerMode = ({
  type,
  className,
  privateOwner,
  setHistoryChanges,
  companyOwner,
  histovecStatus,
  handleKeyPress,
}) => (
  <Container className={`${className}`}>
    {type === 'company' ? (
      <>
        <Row>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="companyName">
              <Translate code="companyName" />
            </Label>
            <Input
              type="text"
              name="companyName"
              id="companyName"
              className="rounded mr-3"
              onChange={(e) => setHistoryChanges(e)}
              value={companyOwner?.companyName || histovecStatus?.companyName}
            />
          </Col>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="siren">
              <Translate code="companySiren" />
            </Label>
            <Input
              type="number"
              name="companySiren"
              id="companySiren"
              className="rounded mr-3"
              maxLength={8}
              onChange={(e) => setHistoryChanges(e)}
              onKeyPress={handleKeyPress}
              value={companyOwner?.companySiren || histovecStatus?.companySiren}
            />
          </Col>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="companyFormula">
              <Translate code="formulaNumber" />
            </Label>
            <Input
              type="text"
              name="companyFormula"
              id="companyFormula"
              className="rounded mr-3"
              maxLength={11}
              onChange={(e) => setHistoryChanges(e)}
              value={companyOwner?.companyFormula || histovecStatus?.companyFormula}
            />
          </Col>
        </Row>
      </>
    ) : (
      <>
        <Row>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="privateName">
              <Translate code="privateName" />
            </Label>
            <Input
              type="text"
              name="privateName"
              id="privateName"
              className="rounded mr-3"
              onChange={(e) => setHistoryChanges(e)}
              value={privateOwner?.privateName || histovecStatus?.privateName}
            />
          </Col>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="privateLastName">
              <Translate code="privateLastName" />
            </Label>
            <Input
              type="text"
              name="privateLastName"
              id="privateLastName"
              className="rounded mr-3"
              onChange={(e) => setHistoryChanges(e)}
              value={privateOwner?.privateLastName || histovecStatus?.privateLastName}
            />
          </Col>
          <Col xs={12} lg={6}>
            <Label className="text-primary font-weight-light text-left" for="privateFormula">
              <Translate code="privateFormula" />
            </Label>
            <Input
              type="text"
              name="privateFormula"
              id="privateFormula"
              maxLength={11}
              className="rounded mr-3"
              onChange={(e) => setHistoryChanges(e)}
              value={privateOwner?.privateFormula || histovecStatus?.privateFormula}
            />
          </Col>
        </Row>
      </>
    )}
  </Container>
);
const Alerts = ({ alerts, level, className, typeAlert }) => {
  if (alerts.find((alert) => alert.levelAlertId === level)) {
    return (
      <tr>
        <td>
          <Button className={className} block disabled>
            <Translate code={typeAlert} />
          </Button>
        </td>
        <td>
          <ul>
            {alerts
              .filter((alert) => alert.levelAlertId === level)
              .map((alert) => (
                <li key={alert.id}>{alert.description}</li>
              ))}
          </ul>
        </td>
      </tr>
    );
  }
  return <></>;
};
const HistovecAlertsTable = ({ histovecAlerts, reportLink, histovecStatus, handleCancel }) => (
  <>
    <span className="histovecInformation pb-3">
      <Translate code="histovecInformation" /> {moment(histovecStatus?.createdAt?.date).format('DD/MM/YYYY')}
    </span>
    <p />
    <Table className="histovec-alerts">
      <thead>
        <tr>
          <th>
            <Translate code="alert_type" />
          </th>
          <th className="message">
            <Translate code="alert_message" />
          </th>
        </tr>
      </thead>
      <tbody>
        <Alerts alerts={histovecAlerts} level={3} className="btn-danger" typeAlert="blockage" />
        <Alerts alerts={histovecAlerts} level={2} className="btn-alert" typeAlert="alert" />
        <Alerts alerts={histovecAlerts} level={1} className="btn-info" typeAlert="information" />
        <tr>
          <td>
            <a href={reportLink || '#'} rel="noopener noreferrer" target="_blank">
              <Translate code="alert_report" />
            </a>
          </td>
        </tr>
      </tbody>
    </Table>
    <ModalFooter className="justify-content-center pt-1">
      <Col xs={12} lg={6}>
        <button className="btn btn-block btn-3" onClick={handleCancel} type="button">
          <Translate code="close" />
        </button>
      </Col>
    </ModalFooter>
  </>
);

AlertModalHistovec.propTypes = {
  toggle: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  setHistoryChanges: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  retriveHistovecInfo: PropTypes.func.isRequired,
  setOwnerMode: PropTypes.func.isRequired,
  ownerMode: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]).isRequired,
  histovecStatus: PropTypes.oneOfType([PropTypes.array]).isRequired,
  histovecAlerts: PropTypes.oneOfType([PropTypes.array]).isRequired,
  privateOwner: PropTypes.oneOfType([PropTypes.object]).isRequired,
  companyOwner: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

HistovecAlertsTable.propTypes = {
  histovecAlerts: PropTypes.oneOfType([PropTypes.array]).isRequired,
  reportLink: PropTypes.string.isRequired,
  histovecStatus: PropTypes.oneOfType([PropTypes.array]).isRequired,
  handleCancel: PropTypes.func.isRequired,
};

Alerts.propTypes = {
  alerts: PropTypes.oneOfType([PropTypes.array]).isRequired,
  className: PropTypes.string.isRequired,
  typeAlert: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
};

SwitchOwnerMode.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  handleKeyPress: PropTypes.func,
  privateOwner: PropTypes.oneOfType([PropTypes.object]),
  setHistoryChanges: PropTypes.func.isRequired,
  companyOwner: PropTypes.oneOfType([PropTypes.object]),
  histovecStatus: PropTypes.func.isRequired,
};

SwitchOwnerMode.defaultProps = {
  privateOwner: undefined,
  companyOwner: undefined,
  handleKeyPress: undefined,
};

Switcher.propTypes = {
  ownerMode: PropTypes.string.isRequired,
  setOwnerMode: PropTypes.func.isRequired,
};
